import React, {useState, useEffect, useRef } from 'react'
import { connect } from "react-redux";
import ConfirmPayment from '@/assets/images/svg/stepper/confirm-payment.svg';
import mailIcon from '@/assets/images/svg/stepper/mail-icon.svg';
import phoneIcon from '@/assets/images/svg/stepper/phone-icon.svg';
import { privateRoutePaths } from '@/routes/private.route.config';
import ButtonAdminpanel from '@/components/ButtonAdminpanel';
import { buildPath,getPrefix } from '@/utils/common';
import { useNavigate } from 'react-router-dom';
import ButtonAdd from '@/components/ButtonAdd';
import { getSupplierMember } from "@/actions/stepperAction";
import { hideLoading, showLoading } from "@/actions/loaderAction";
import { useAuth } from "../../AuthProvider";
import moment from 'moment';
import { isEqual } from 'lodash';


const MAX_RETRIES = 3;
const RETRY_DELAY_MS = 2000;

const PaymentSuccess = (props) => {
  const nav = useNavigate();
  const { memberCompanyID, setUser, user } = useAuth();

  const [supplierMember, setSupplierMember] = useState([]);

  const retryCount = useRef(0);
  const timerRef = useRef(null);
  const hasLoadedRef = useRef(false);
  const inFlightRef = useRef(false);


  const scheduleRetry = () => {
    if (hasLoadedRef.current) return;

    if (retryCount.current < MAX_RETRIES) {
      retryCount.current += 1;
      timerRef.current = setTimeout(() => {
        fetchSupplier();
      }, RETRY_DELAY_MS);
    } 
  };

  const fetchSupplier = async () => {
    if (hasLoadedRef.current || inFlightRef.current || !memberCompanyID) return;

    inFlightRef.current = true;
    try {
      const response = await props.getSupplier(memberCompanyID,"/upgrade_plan");
      const details = response?.data?.user_details;
      setSupplierMember(response?.data);
      let oldData = localStorage.getItem("user");
      console.log("old Data ============== ", oldData);
      console.log("details ==================", details);
      localStorage.setItem("user", JSON.stringify(details));
      setUser(details);

      /*
      const planActive =
        !!details &&
        !!details.company_plan_name &&
        details.company_plan_name !== "Trial";

      if (response?.status !== true || !planActive) {
        inFlightRef.current = false;
        scheduleRetry();
        return;
      }

      // CASE 3: refresh par bhi isi page par rahe -> koi redirect nahi, bas data dikhao
      hasLoadedRef.current = true;
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }

      const seenKey = `payment_success_seen:${memberCompanyID}:${response.data.step_1?.plan_to_date}`;

      localStorage.setItem("user", JSON.stringify(details));
      setSupplierMember(response.data);
      setUser(details);

      // CASE 1: pehli baar success -> baaki tabs ko signal (ye tab khud isse affect nahi hota)
      if (!localStorage.getItem(seenKey)) {
        localStorage.setItem(seenKey, "1");
        localStorage.setItem("payment_success_at", String(Date.now()));
      } */
    } catch (err) {
      console.log("Error =", err);
      inFlightRef.current = false;
      scheduleRetry();
    }
  };

  useEffect(() => {
    if (!memberCompanyID || hasLoadedRef.current) return;

    fetchSupplier();

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [memberCompanyID]);

    
      
  
  return (
    <div className='upgrade-container container-fluid'>
     <div className='upgrade-layout content-wrap'>
     <div className='confirm-step-wrape'>
         <div className='confirm-icon'>
            <img src={ConfirmPayment} alt="confirm-payment" />
         </div>

         <div className='confirm-heading'>
            <h2>Your { supplierMember && supplierMember.step_3 && supplierMember.step_3.plan_name } plan is Now Active!.</h2>
         </div>
         <div className='confirm-decs'>
           <p>Complete your profile to increase visibility, attract relevant buyer inquiries, and start building global business connections.</p>
         
         </div>
          <div className='confirm-plan-box card'>
            { supplierMember.step_3 && supplierMember.step_3.plan_name != "Trial" &&
              <div className="card-body">
                 
                  {
                    supplierMember && supplierMember.step_1 &&<p>Validity: <span> { moment(supplierMember.step_1.plan_from_date).format('DD/MM/YYYY') } to { 
                      moment(supplierMember.step_1.plan_to_date).format('DD/MM/YYYY') }</span></p>
                  } 
                  {
                    supplierMember && supplierMember.step_3 && <p>Plan: <span>{ supplierMember.step_3.plan_name }</span></p>
                  }
             
               </div>
            }
               
          </div>
           <div className='confirm-btn'>
                <ButtonAdminpanel className="mt-3" type="submit" onClick={() => nav(`/${getPrefix(user)}${buildPath(privateRoutePaths.PRE_KYC_DASHBOARD)}`)}>
                    Go to Dashboard
                </ButtonAdminpanel>
                   <ButtonAdd className="mt-3 ms-3 upgrade-add-btn" type="submit"
                  onClick={() => nav(`/${getPrefix(user)}${buildPath(privateRoutePaths.UPDATE_COMPANY_PROFILE, { id: memberCompanyID })}`) }
                  >
                    Update Profile
                  </ButtonAdd>
               
                

            </div>

           <div className='confirm-contact border-top '>
                   <span>Need assistance? Contact our support team:</span>
                  <a href={`mailto:${process.env.REACT_APP_CONNECT_MAIL}`} className="contact-item">
                     <img src={mailIcon} alt="mail-iocn" />
                      {/* {process.env.REACT_APP_CONNECT_MAIL}  */}
                      connect@orextrade.com
                   </a>
                      <a href={`tel:${process.env.REACT_APP_CONNECT_WHATSAPP_NUMBER}`} className="contact-item">
                      <img src={phoneIcon} alt="phone-icon" />
                      {/* {process.env.REACT_APP_CONNECT_WHATSAPP_NUMBER}  */}
                      +91 98981 16349
                   </a>
            </div>   

            {
              // supplierMember && supplierMember.step_3 && supplierMember.step_3.plan_name == "Trial" && <div className='profile-button border-top'>
              //     <BackButton className="mt-3" type="submit" onClick={props.onPrev} >
              //         Back
              //     </BackButton>
              //   </div>
            }
            
    </div>
    </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading()),   
    getSupplier: (member_id,page_type) => dispatch(getSupplierMember(member_id,page_type))
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(PaymentSuccess);

